import axios from "axios";

const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";

const om = {
  /**
   * Realizar request genérica a la API
   * @param {Object} endPoint endpoint de la API
   * @param {Object} payload payload para el endpoint
   * @param {String} method método HTTP (GET, POST, etc.)
   */
  request({ endPoint, payload, method }) {
    const body = payload ? JSON.parse(JSON.stringify(payload)) : payload;

    if (method && method.toUpperCase() === "GET") {
      return axios.get(`${API_BASE_SRC}/${endPoint}`);
    }

    return axios.post(`${API_BASE_SRC}/${endPoint}`, body);
  }
};

export default om;
